import React from 'react';
import { IconButton, Position, RepeatIcon, Tooltip, toaster } from 'evergreen-ui';
import { useRepeatMessageIncomingProcessMutation } from 'Services/api/messageApi';

type Props = {
  messageId: number | undefined,
};
export const RepeatMessageProcess = React.memo(({ messageId }: Props) => {
  const [postRepeatMessageIncomingProcess] = useRepeatMessageIncomingProcessMutation();
  const onClick: React.MouseEventHandler<HTMLButtonElement> = () => {
    if (messageId !== undefined && messageId !== null) {
      postRepeatMessageIncomingProcess(messageId)
        .unwrap()
        .then(() => {
          toaster.success('Успешно!');
        })
        .catch(() => toaster.warning(`Ошибка повторного разбора для сообщения ${messageId}`));
    }
  };
  return (
    <Tooltip content="Повторный разбор" position={Position.LEFT}>
      <IconButton
        appearance="minimal"
        icon={RepeatIcon}
        style={{ color: 'rgba(251, 190, 36, 1)' }}
        // @ts-ignore
        intent="default"
        onClick={onClick}
      />
    </Tooltip>
  );
});
RepeatMessageProcess.displayName = 'MemoRepeatMessageProcess';
export default RepeatMessageProcess;
